import { constants } from "@thecb/components";

const { ROYAL_BLUE_VIVID } = constants.colors;

const iconColor = ROYAL_BLUE_VIVID;

export const fallbackValues = {
  iconColor
};
